import React from 'react'
import { Outlet } from 'react-router-dom'

export const DeviceBase: React.FC = () => {
  return <Outlet />
}
